// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__lI3hX","parentTitle":"Breadcrumbs_parentTitle__CGbTJ"};